document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.aura-register').forEach(initAuraRegister);
});

function initAuraRegister(root){
  /* Desktop Tabs */
  const tabs   = root.querySelectorAll('.ar-tab');
  const panels = root.querySelectorAll('[data-ar-panel]');

  tabs.forEach((btn, idx) => {
    btn.addEventListener('click', () => {
      tabs.forEach((b, i) => {
        const active = i === idx;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-selected', active ? 'true' : 'false');
        panels[i].classList.toggle('is-active', active);
        if (active) panels[i].removeAttribute('hidden'); else panels[i].setAttribute('hidden','');
      });
    });
  });

  /* Mobile Accordion – immer nur eine Lasche offen */
  const accordions = root.querySelectorAll('.ar-mobile .ar-acc');
  accordions.forEach(acc => {
    acc.addEventListener('toggle', () => {
      if (acc.open) {
        accordions.forEach(other => { if (other !== acc) other.removeAttribute('open'); });
      }
    });
  });
}
